angular.module('impactx.panel').directive('ixTenderPreviewPanel', TenderPreviewPanelDirective);

function TenderPreviewPanelDirective() {
    return {
        restrict: 'EA',
        controller: 'TenderPreviewPanelCtrl',
        controllerAs: 'tenderPreviewPanelCtrl',
        scope: true,
        bindToController: {
            name: "=",
            image: "=",
            trns: "=",
            mainProductGroup: "=",
            siteNumber: "=",
            treatmentType: "="
        },
        templateUrl: 'shared/panel/templates/tender.preview.panel.tmpl.html'
    }
}